import { useEffect, useState } from 'react';

const TOTAL_DURATION_S = 5;

export const usePlayback = (tMax: number | null) => {
  const [t, setT] = useState(0);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    if (!playing || !tMax) return;
    let cancelled = false;
    let lastFrame: number | null = null;
    const speed = tMax / TOTAL_DURATION_S;
    const tick = (now: number) => {
      if (cancelled) return;
      if (lastFrame == null) lastFrame = now;
      const dt = (now - lastFrame) / 1000;
      lastFrame = now;
      setT(prev => {
        const next = prev + dt * speed;
        if (next >= tMax) {
          setPlaying(false);
          return tMax;
        }
        return next;
      });
      if (!cancelled) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
    return () => {
      cancelled = true;
    };
  }, [playing, tMax]);

  return { t, setT, playing, setPlaying };
};
